import { defineStore } from 'pinia'
import http from '../helpers/http-call'
import { ENDPOINT_URL } from '../helpers/api'
import * as localStorage from '../helpers/local-storage'
import { decryptJson, encryptJson } from '../helpers/crypto'

export interface IAuthState {
  token: string
  loading: boolean
  data: {
    hotel_id: number
    token: string
    expired_date: string
  }
  hotelId: number
  name: string
}
export interface IAuthQuery {
  showData: boolean
}
const TOKEN = import.meta.env.VITE_APP_TOKEN_JWT
const template = (import.meta.env.VITE_APP_TEMPLATE)?.toLowerCase() || 'savoy'
const name = `${(import.meta.env.VITE_APP_HOTEL_NAME)?.toLowerCase()}_${TOKEN
? TOKEN.substring((TOKEN.length - 5))
: `${import.meta.env.VITE_APP_HOTEL_ID}AA`}_${template}`
// let version = VITE_APP_VERSION ? `_${import.meta.env.VITE_APP_VERSION}` : null
// if (version) {
//   version = version.replaceAll('.', '_')
//   name += version
// }
export const AUTH_DATA = {
  hotel_id: 0,
  token: '',
  expired_date: '',
}
const jwt = (import.meta.env.VITE_APP_TOKEN_JWT as string).replace(/Bearer /g, '')
export const useAuthStore = defineStore('auth', {
  state: (): IAuthState => {
    return {
      token: jwt,
      hotelId: Number(import.meta.env.VITE_APP_HOTEL_ID),
      loading: false,
      data: AUTH_DATA,
      name,
    }
  },
  getters: {
    getToken(): IAuthState['token'] {
      return this.token
    },
    getData(): IAuthState['data'] {
      return this.data
    },
    getDecryptToken() {
      return (slug: string) => slug ? decryptJson(slug, jwt) : {}
    },
    getEncryptToken() {
      return (slug: string) => slug ? encryptJson(slug, jwt) : ''
    },
    getCurToken(): string {
      return this.data && this.data.token ? this.data.token.replace(/Bearer /g, '') : ''
    },
    getDataToken(): string {
      const storage: IAuthState['data'] = this.getStorage
      const token = storage?.token ? storage.token : this.token
      return token ? token.replace(/Bearer /g, '') : ''
    },
    getStorage(): IAuthState['data'] {
      const local = localStorage.getItem(`${name}_token`)
      let storage: IAuthState['data'] = AUTH_DATA
      try {
        if (local)
          storage = JSON.parse(local)
      }
      catch (e) {}
      return storage
    },
  },
  actions: {
    async setData(query: IAuthQuery) {
      const {
        showData,
      }: IAuthQuery = query
      let data = AUTH_DATA
      this.loading = true
      const response = await http.call({
        url: `${ENDPOINT_URL}/get-token`,
        params: {
          hotel_id: this.hotelId,
          days: 30,
        },
        method: 'GET',
        data: null,
      })
      this.loading = false
      if (response?.data?.data) {
        const {
          token,
          ...obj
        } = response.data?.data
        data = {
          ...obj,
          token,
        }
        localStorage.setItem(`${name}_token`, JSON.stringify(data))
      }
      this.data = data

      if (showData)
        return data
    },
    async setList(data: IAuthState) {
      this.token = data['token']
    },
  },
})
